import {
  Box,
  Button,
  CardHeader,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  LinearProgress,
  Paper,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
  TextField,
  Alert,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useQuery } from "../../../hooks/useQuery";
import { SQCQuestionService } from "../../../service/SQC_form/SQCQuestionService";
import { LoadingButton } from "@mui/lab";
import { SQCReponseService } from "../../../service/SQC_form/SQCReponseService";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ResumePostule from "./ResumePostule";
import { useNavigate } from "react-router-dom";
import { userServices } from "../../../service/UserService";
import useNotification from "../../../hooks/useNotification";
import useConfirmation from "../../../hooks/useConfirmation";
import { DeleteOutline } from "@mui/icons-material";
import { AssociationCandidatService } from "../../../service/AssociationCandidatService";
import { useTheme, useMediaQuery } from "@mui/material";
import { getConnectedUser } from "../../../Helpers/SessionHelpers";
import { OffreService } from "../../../service/OffreService";
import usePrompt from "../../../hooks/usePrompt";

const INIT_QUESITON_INFO = {
  id_sqc_question: null,
  id_sqc_form: 0,
  // created_at: null,
  // updated_at: Date(),
  question: "",
  qs_requis: "1",
  pj_requis: "0",
  allow_comment: "0",
  type_reponse: "1",
};
const INIT_REPONSE_INFO = {
  id_sqc_reponse: null,
  id_sqc_question: 0,
  id_candidat: 0,
  reponse: "",
  pj: null,
  commentaire: null,
  // created_at: Date(),
  // updated_at: Date(),
};
const INIT_FORM_ERROR = {
  reponse_error: null,
  pj_error: null,
  commentaire_error: null,
};

export const TYPE_REPONSE = [
  { id: "1", reponse_name: "Oui/Non" },
  { id: "2", reponse_name: "Champ libre" },
  { id: "3", reponse_name: "Champ en chiffre" },
];

const VolontariatPostuleForm = () => {
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [showResume, setShowResume] = useState(false);
  const [acceptCondition, setAcceptCondition] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(INIT_QUESITON_INFO);
  const [currentReponse, setCurrentReponse] = useState(INIT_REPONSE_INFO);
  const [formError, setFormError] = useState(INIT_FORM_ERROR);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedAssociation, setSelectedAssociation] = useState({});
  const [associationStatus, setAssociationStatus] = useState({});
  const [selectedOffre, setSelectedOffre] = useState({});
  const [associationDejaPostulant, setAssociationDejaPostulant] =
    useState(false);
  const { Toast, showToast } = useToast();
  const { NotificationComponent, showNotification } = useNotification();
  const { DialogComponent, openConfirmDialog } = useConfirmation();
  const url = useQuery();
  const navigate = useNavigate();
  const jobId = url.get("job_id");
  const [dirty, setDirty] = useState(true);
  const [nextPath, setNextPath] = useState(null);

  usePrompt(
    "Vous avez des modifications non sauvegardées. Voulez-vous vraiment quitter ?",
    dirty
  );

  const handleFetchQuestions = React.useCallback(() => {
    SQCQuestionService.listByType(jobId).then((res) => {
      if (res && res.success) {
        setQuestions(res.data);
      }
    });
  }, [jobId]);

  const handleFetchCurrentOffre = React.useCallback(() => {
    OffreService.findOneById(jobId).then((res) => {
      if (res && res.success) {
        setSelectedOffre(res.data);
      }
    });
  }, [jobId]);

  const handleFetchReponse = () => {
    setLoadingPage(true);
    SQCReponseService.findByQuestionAndCandidat(currentQuestion.id_sqc_question)
      .then((res) => {
        if (res && res.success) {
          setCurrentReponse(res.data);
        } else {
          setCurrentReponse({
            ...INIT_REPONSE_INFO,
            id_sqc_question: currentQuestion.id_sqc_question,
          });
        }
      })
      .finally(() => {
        setLoadingPage(false);
      });
  };

  const handleFetchCurrentAssociation = () => {
    userServices.getMyAssociation().then((res) => {
      if (res && res.success) {
        setSelectedAssociation(res.data);
      } else {
        openConfirmDialog(
          "Aucune association trouvée",
          "Vous n'avez pas encore d'une association, Voullez vous en creer une?",
          () => {
            navigateTo("/mon-profile?tab=1&job_id=" + jobId);
          },
          () => {
            navigateTo("/offre-emploi");
          }
        );
      }
    });
  };

  const handleFetchAssociationStatus = (selectedAssociation) => {
    AssociationCandidatService.getAssociationStatus({
      id_ext_association: selectedAssociation.id_ext_association,
    }).then((res) => {
      if (res && res.success) {
        setAssociationStatus(res.data);
        if (res.data.nb_experience === "0" || res.data.nb_membre === "0") {
          handleConfirmAddMembreAndExperience();
        }
      }
    });
  };

  const handleConfirmAddMembreAndExperience = () => {
    openConfirmDialog(
      "Experience manquante",
      "Vous n'avez pas encore ajouter d'experience, Voullez vous en ajouter ?",
      () => {
        navigateTo("/mon-profile?tab=1&ass_tab=1&job_id=" + jobId);
      },
      () => {
        navigateTo("/offre-emploi");
      }
    );
  };

  const handleSave = () => {
    if (!handleCheckError()) {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Veuillez verifier les champs avec erreur."
      );
      return;
    } else {
      if (!currentReponse?.id_sqc_reponse) {
        handleInsert();
      } else {
        handleUpdate();
      }
    }
  };

  const handleCheckError = () => {
    setFormError({
      reponse_error:
        currentQuestion?.qs_requis === "1" && !currentReponse?.reponse
          ? "Reponse est requis"
          : null,
      pj_error:
        !currentReponse?.pj &&
        currentQuestion?.pj_requis === "1" &&
        ((String(currentReponse?.reponse || "").toUpperCase() !== "NON" &&
          currentQuestion.type_reponse === "1") ||
          currentQuestion.type_reponse !== "1") /* || !selectedFile */
          ? "Piece jointe est requis"
          : null,
      commentaire_error:
        currentQuestion?.allow_comment === "1" &&
        currentQuestion?.comment_requis === "1" &&
        String(currentReponse?.commentaire).trim() === ""
          ? "Commentaire ou description est obligatoire"
          : null,
    });
    return Object.values(formError).every((error) => error === null);
  };

  const handleUpdate = () => {
    setSubmitting(true);
    SQCReponseService.update(currentReponse, selectedFile)
      .then((res) => {
        if (res && res.success) {
          if (res.message === "0 Donée mis à jour") {
            handleNext();
          } else {
            showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
            handleNext();
          }
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleInsert = () => {
    setSubmitting(true);
    SQCReponseService.insert(currentReponse, selectedFile)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleNext();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleSetCurrentReponse = (e) => {
    const { name, value } = e.target;
    setCurrentReponse({ ...currentReponse, [name]: value });
  };

  const handleRetour = () => {
    let newIndex = currentIndex <= 0 ? 0 : currentIndex - 1;
    setCurrentIndex(newIndex);
    handleClearFile();
  };
  const handleNext = () => {
    let newIndex = currentIndex + 1;
    // currentIndex === questions.length - 1 ||
    // currentIndex > questions.length - 1
    //   ? questions.length - 1
    //   : currentIndex + 1;
    setCurrentIndex(newIndex);
    handleClearFile();
  };

  const handleClearFile = () => {
    setSelectedFile(null);
    const fileInput = document.getElementById("fileInput");
    if (fileInput) fileInput.value = null;
  };

  React.useEffect(() => {
    if (dirty === false && nextPath) {
      navigate(nextPath);
    }
  }, [dirty, nextPath, navigate]);

  const navigateTo = (path) => {
    setDirty(false);
    setNextPath(path);
  };

  const handleAbordApply = () => {
    openConfirmDialog(
      "Quitter formulaire",
      "Voullez vous vraiment quitter?",
      () => {
        navigateTo("/offre-emploi");
      },
      () => {}
    );
  };

  const handleFinalizeCandidature = () => {
    openConfirmDialog(
      "Postuler maintenant",
      "Voulez vous postuler maintenant?",
      () => {
        handleConfirmFinalizeCandidature();
      },
      () => {}
    );
  };

  const handleDeletePj = () => {
    handleSetCurrentReponse({
      target: {
        name: "pj",
        value: null,
      },
    });
    handleClearFile();
  };

  const handleConfirmDeletePj = () => {
    openConfirmDialog(
      "Supprimer PJ",
      "Voullez vous supprimer cette pièce jointe?",
      () => {
        handleDeletePj();
      },
      () => {}
    );
  };

  const handleFetchAssociationCandidatByType = () => {
    setSubmitting(true);
    AssociationCandidatService.getAssociationCandidatureByType(
      selectedAssociation.id_ext_association,
      jobId
    )
      .then((res) => {
        if (res && res.data) {
          setAssociationDejaPostulant(res.data !== null);
        } else {
          setAssociationDejaPostulant(false);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleConfirmFinalizeCandidature = () => {
    setSubmitting(true);
    AssociationCandidatService.postuler({
      id_ext_association: selectedAssociation.id_ext_association,
      id_type: url.get("job_id"),
    })
      .then((res) => {
        if (res && res.success) {
          showNotification(
            "Succès",
            // "Votre candidature a été soumise avec succès.",
            res.message,
            TYPE_NOTIFICATION.SUCCESS,
            () => {
              navigateTo("/offre-emploi");
              // navigate("/offre-emploi");
            },
            "Fermer"
          );
        } else {
          showNotification(
            "Erreur",
            // "Votre candidature a été soumise avec succès.",
            res.message,
            TYPE_NOTIFICATION.ERROR,
            () => {},
            "Fermer"
          );
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    handleFetchCurrentAssociation();
    handleFetchQuestions();
    handleFetchCurrentOffre();
  }, [handleFetchQuestions, handleFetchCurrentOffre, jobId]);

  useEffect(() => {
    if (currentReponse || currentQuestion) handleCheckError();
  }, [currentReponse, currentQuestion]);

  useEffect(() => {
    if (questions.length > 0 && currentIndex < questions.length) {
      setCurrentQuestion(questions.at(currentIndex));
    }
    setShowResume(currentIndex >= questions.length);
    if (currentIndex >= questions.length) {
      handleFetchAssociationCandidatByType();
    }
  }, [currentIndex, questions]);

  useEffect(() => {
    if (currentQuestion.id_sqc_question) handleFetchReponse();
  }, [currentQuestion]);

  useEffect(() => {
    if (selectedAssociation.id_ext_association) {
      handleFetchAssociationStatus(selectedAssociation);
    }
  }, [selectedAssociation]);

  // responsivité
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <NotificationComponent />
      <DialogComponent />
      <Toast />
      <Grid container justifyContent={"center"}>
        <Grid item ml={1} xs={12} md={10} xl={8}>
          <Paper key={currentIndex}>
            <Grid container>
              <Grid container alignItems={"center"} mt={2} mr={2} ml={2}>
                <Grid item flexGrow={1}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
                    }}
                  >
                    Formulaire de soumission
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    color="error"
                    size="small"
                    variant="outlined"
                    onClick={handleAbordApply}
                  >
                    Quitter
                  </Button>
                </Grid>
              </Grid>
              <Grid container m={2} display={!loadingPage ? "none" : ""}>
                <Skeleton width={"100%"} />
                <Skeleton width={"100%"} />
                <Skeleton width={"100%"} />
                <Skeleton width={"100%"} />
              </Grid>

              {!loadingPage && (
                <>
                  <Grid container mr={2} ml={2}>
                    <ResumePostule
                      show={showResume && questions.length > 0}
                      jobId={jobId}
                      onAcceptCondition={setAcceptCondition}
                      setCurentIndex={setCurrentIndex}
                    />
                  </Grid>
                  <Grid
                    container
                    m={2}
                    display={questions.length === 0 ? "" : "none"}
                    justifyContent={"center"}
                  >
                    <CardHeader
                      title={
                        <p style={{ fontSize: "1.1rem" }}>
                          Aucun formulaire disponible pour ce Lot.
                        </p>
                      }
                      titleTypographyProps={{
                        variant: "h6",
                        textAlign: "center",
                      }}
                    />
                  </Grid>
                  <Grid
                    container
                    display={
                      questions.length === 0 || !currentQuestion || showResume
                        ? "none"
                        : ""
                    }
                  >
                    <Grid container p={3} alignContent={"center"}>
                      <Grid item xs={12}>
                        <Typography
                          pb={1}
                          variant="body2"
                          color="textSecondary"
                        >
                          AMI : {selectedOffre?.libelle_type}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            lineHeight: 1.6,
                            fontWeight: 500,
                            color: "#888",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: { xs: "0.9rem", sm: "1rem" },
                          }}
                        >
                          Toutes les questions avec (
                          <span style={{ color: "red" }}>*</span>) sont à
                          repondre obligatoirement
                        </Typography>
                        <Alert
                          severity="info"
                          variant="outlined"
                          sx={{ mt: 2 }}
                        >
                          Veuillez rassurer que vous avez ajoutés toutes les
                          experiences professionnelles de l'association.
                          <Button
                            size="small"
                            onClick={(e) => {
                              navigateTo(
                                "/mon-profile?tab=1&ass_tab=1&job_id=" + jobId
                              );
                            }}
                          >
                            cliquer pour en ajouter 
                          </Button>
                        </Alert>
                      </Grid>
                    </Grid>
                    <Grid container p={3} alignContent={"center"}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            xs: "1rem",
                            sm: "1.2rem",
                            md: "1.25rem",
                            lg: "1.35rem",
                          },
                          lineHeight: 1.6,
                          fontWeight: 400,
                          color: "#333",
                          fontFamily: "Roboto, sans-serif",
                        }}
                      >
                        {`${currentIndex + 1}. ${currentQuestion.question}`}
                        {currentQuestion.qs_requis === "1" && (
                          <span style={{ color: "red" }}> *</span>
                        )}
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      minHeight={80}
                      justifyContent={"center"}
                      alignContent={"center"}
                      display={
                        currentQuestion.type_reponse === "1" ? "" : "none"
                      }
                    >
                      <Grid item xs={10} justifyItems={"center"}>
                        <RadioGroup
                          row
                          onChange={(e) =>
                            handleSetCurrentReponse({
                              target: {
                                name: "reponse",
                                value: e.target.value,
                              },
                            })
                          }
                          value={currentReponse?.reponse}
                          name="reponse"
                        >
                          <FormControlLabel
                            value="OUI"
                            control={<Radio />}
                            label="OUI"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: { xs: "0.95rem", sm: "1.05rem" },
                              },
                            }}
                          />
                          <FormControlLabel
                            value="NON"
                            control={<Radio />}
                            label="NON"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: { xs: "0.95rem", sm: "1.05rem" },
                              },
                            }}
                          />
                        </RadioGroup>
                      </Grid>
                      <Grid item p={3} xs={12}>
                        <Grid item>
                          <FormHelperText
                            sx={{
                              fontSize: { xs: "0.85rem", sm: "0.95rem" },
                              display: formError.reponse_error ? "" : "none",
                            }}
                          >
                            <Alert severity="error" variant="outlined">
                              {formError.reponse_error}
                            </Alert>
                          </FormHelperText>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      mr={3}
                      ml={3}
                      // justifyContent={"center"}
                      alignContent={"center"}
                      display={
                        ["2", "3"].includes(currentQuestion?.type_reponse)
                          ? ""
                          : "none"
                      }
                    >
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <label>
                            Votre reponse
                            {currentQuestion?.qs_requis === "1" && (
                              <span style={{ color: "red" }}> *</span>
                            )}
                          </label>
                          <TextField
                            name="reponse"
                            size="small"
                            type={
                              currentQuestion?.type_reponse === "3"
                                ? "number"
                                : "text"
                            }
                            onChange={handleSetCurrentReponse}
                            value={currentReponse?.reponse}
                            placeholder="Reponse"
                            error={formError.reponse_error}
                            helperText={formError.reponse_error}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      m={3}
                      // justifyContent={"center"}
                      alignContent={"center"}
                      display={
                        currentQuestion.allow_comment === "1" ? "" : "none"
                      }
                    >
                      <Grid item xs={12} mt={2}>
                        <FormControl fullWidth>
                          <label>
                            Commentaire/Description
                            {currentQuestion?.comment_requis === "1" && (
                              <span style={{ color: "red" }}> *</span>
                            )}
                          </label>
                          <TextField
                            name="commentaire"
                            multiline
                            rows={5}
                            onChange={handleSetCurrentReponse}
                            value={currentReponse?.commentaire || ""}
                            placeholder="Votre commentaire ou description"
                            error={formError.commentaire_error ?? false}
                            helperText={formError.commentaire_error}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container mr={3} ml={3}>
                      <FormControl fullWidth>
                        <label style={{ fontSize: "1rem" }}>
                          Piece jointe{" "}
                          {currentQuestion?.pj_requis === "1" && (
                            <span style={{ color: "red" }}> *</span>
                          )}
                        </label>
                        <Grid
                          style={{
                            display: currentReponse?.pj ? "none" : "block",
                          }}
                        >
                          <input
                            type="file"
                            id="fileInput"
                            name="pj"
                            onChange={(evt) => {
                              setSelectedFile(evt.target.files[0]);
                              handleSetCurrentReponse({
                                target: {
                                  name: "pj",
                                  value: evt.target.files[0].name,
                                },
                              });
                            }}
                          />
                          <Grid mt={1}>
                            <FormHelperText
                              sx={{
                                fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                display: formError.pj_error ? "" : "none",
                              }}
                            >
                              <Alert severity="error" variant="outlined">
                                {formError.pj_error}
                              </Alert>
                            </FormHelperText>
                          </Grid>
                          <Grid mt={1}>
                            <Alert severity="info" variant="outlined">
                              - Vous pouvez compresser vos fichiers en zip si
                              plusieurs. <br />
                              - Type du fichier autorisé: jpg, jpeg, png, gif,
                              pdf, zip.
                              <br />- Taille maximale: 3 Mo.
                            </Alert>
                          </Grid>
                        </Grid>
                        <Paper
                          elevation={0}
                          sx={{
                            marginTop: 1,
                            p: 0.5,
                            border: "1px solid rgba(30,30,30,0.15)",
                            display: currentReponse?.pj ? "block" : "none",
                            backgroundColor: "transparent",
                          }}
                        >
                          <Grid
                            container
                            display={"flex"}
                            flexDirection={"row"}
                          >
                            <Grid
                              item
                              xs={10}
                              alignContent={"center"}
                              overflow={"hidden"}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: "0.9rem", sm: "1rem" },
                                  fontFamily: "Roboto, sans-serif",
                                }}
                              >
                                {currentReponse?.pj}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Grid
                                container
                                spacing={1}
                                justifyContent={"flex-end"}
                              >
                                <Grid item>
                                  <Button
                                    title="Supprimer la pièce jointe"
                                    size="small"
                                    color="error"
                                    onClick={handleConfirmDeletePj}
                                  >
                                    <DeleteOutline />
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Paper>
                      </FormControl>
                    </Grid>
                    <Grid container m={2} justifyContent={"center"}>
                      <Chip
                        variant="outlined"
                        color="primary"
                        size="small"
                        label={`N°${currentIndex + 1} / ${questions.length}`}
                        sx={{
                          fontSize: { xs: "0.85rem", sm: "0.95rem" },
                          height: { xs: 24, sm: 28 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              <Grid
                container
                justifyContent={"space-between"}
                alignContent={"center"}
                spacing={1}
                display={loadingPage ? "none" : "flex"}
                m={1}
              >
                <Grid item>
                  <LoadingButton
                    startIcon={<NavigateBeforeIcon />}
                    onClick={handleRetour}
                    size="small"
                    disabled={currentIndex === 0}
                    sx={{
                      fontSize: { xs: "0.95rem", sm: "1.05rem" },
                    }}
                  >
                    Precedent
                  </LoadingButton>
                </Grid>
                <Grid item>
                  <Tooltip
                    title={
                      !acceptCondition && showResume
                        ? `Veuillez accepter le condition "je soussigné(s) ${getConnectedUser()?.full_name} ..." pour postuler.`
                        : ""
                    }
                    arrow
                  >
                    <span>
                      <LoadingButton
                        variant={showResume ? "contained" : "text"}
                        endIcon={showResume ? null : <NavigateNextIcon />}
                        disabled={
                          currentIndex >= questions.length + 1 ||
                          questions.length === 0 ||
                          (!acceptCondition && showResume)
                        }
                        loading={submitting}
                        size="small"
                        onClick={
                          showResume ? handleFinalizeCandidature : handleSave
                        }
                        sx={{
                          fontSize: { xs: "0.95rem", sm: "1.05rem" },
                        }}
                      >
                        {showResume
                          ? /* associationDejaPostulant ? "Modifier" : "Postuler" */
                            "Valider"
                          : isSmallScreen
                            ? "Suivant"
                            : "Enregistrer & suivant"}
                      </LoadingButton>
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
              <Box sx={{ width: "100%" }}>
                <LinearProgress
                  color={
                    ((currentIndex + 1) / questions.length) * 100 < 100
                      ? "info"
                      : "success"
                  }
                  variant="determinate"
                  value={((currentIndex + 1) / questions.length) * 100}
                  sx={{ borderRadius: "0 0 15px 15px" }}
                />
              </Box>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default VolontariatPostuleForm;
